import * as React from 'react';
import { Route } from 'react-router-dom';
import withAuthentication from 'components/withAuthentication';
import LoginPage from '../LoginPage';

class SSORoute extends React.Component {
  componentDidMount() {
    this.props.setAuthToSSO();
  }
  render() {
    const { component: Component, isAuthenticatedWithSSO, hasInitializedSSO, ...routeProps } = this.props;

    return (
      <Route
        {...routeProps}
        render={(props) =>
          isAuthenticatedWithSSO ? (
            <Component isSSO={true} {...props} />
          ) : (
            <LoginPage data-testid="login-form" isSSO={true} hasInitializedSSO={hasInitializedSSO} />
          )
        }
      />
    );
  }
}

export default withAuthentication(SSORoute);
